import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from '@/shared/components/AdminLayout.tsx';
import { DashboardPage } from '@/features/dashboard/index.ts';
import { TenantListPage, TenantStatusPage } from '@/features/tenants/index.ts';
import { IncidentListPage } from '@/features/incidents/index.ts';
import { MaintenanceListPage } from '@/features/maintenances/index.ts';
import { ProbeLogListPage } from '@/features/probe-logs/index.ts';
import { ReportsPage } from '@/features/reports/index.ts';
import { AdminUserListPage } from '@/features/admin-users/index.ts';
import { DeployDraftListPage } from '@/features/deploy-drafts/index.ts';
import { DeploySourceListPage } from '@/features/deploy-sources/index.ts';
import { StatusPage } from '@/pages/public/StatusPage.tsx';
import { LoginPage } from '@/pages/LoginPage.tsx';
import { RequireAuth } from './guards/RequireAuth.tsx';

export function AppRouter() {
  return (
    <Routes>
      {/* ── Rotas públicas ──────────────────────────── */}
      <Route path="/uptime" element={<StatusPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* ── Rotas admin (protegidas) ────────────────── */}
      <Route element={<RequireAuth />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="tenants" element={<TenantListPage />} />
          <Route path="tenants/:id/status" element={<TenantStatusPage />} />
          <Route path="incidents" element={<IncidentListPage />} />
          <Route path="maintenances" element={<MaintenanceListPage />} />
          <Route path="deploys" element={<DeployDraftListPage />} />
          <Route path="deploy-sources" element={<DeploySourceListPage />} />
          <Route path="probe-logs" element={<ProbeLogListPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="users" element={<AdminUserListPage />} />
        </Route>
      </Route>

      {/* Redirecionar / para /admin */}
      <Route path="/" element={<Navigate to="/admin" replace />} />

      {/* Fallback */}
      <Route
        path="*"
        element={
          <div className="flex h-screen items-center justify-center font-sans">
            <p className="text-lg text-gray-500">Página não encontrada</p>
          </div>
        }
      />
    </Routes>
  );
}
